import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Stack,
  Center,
  Card,
  Alert,
  Text,
  Button,
  Select,
  Loader,
  TextInput,
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import {
  BOB_MODALS,
  currencyCodes,
  TWO_FACTOR_INTERVALS,
} from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import TwoFactorInput from "../details/twoFactorInput";

const TwoFactorTimeout = observer(({ bob }: { bob: Bob }) => {
  const [twoFACode, setTwoFACode] = useState<string>("");
  const [selectedInterval, setSelectedInterval] = useState<string | null>(
    bob.workspace.accountTwoFactorIntervalMinutes.toString()
  );
  const handleClose = () => {
    bob.setOpenModal(undefined);
  };

  const handleSave = () => {
    bob.sendDataAndDirectiveToRails("change-two-factor-timeout", {
      twoFactorCode: twoFACode,
      newTwoFactorIntervalMinutes: Number(selectedInterval),
    });
  };

  // console.log(
  //   "bob.workspace.accountTwoFactorIntervalMinutes",
  //   bob.workspace.accountTwoFactorIntervalMinutes
  // );

  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.TWO_FACTOR_TIMEOUT}
      onClose={handleClose}
      // size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
      title="Change Two-Factor Timeout"
    >
      <Stack gap="sm">
        <Select
          label="2FA Timeout"
          placeholder="Select timeout interval"
          data={TWO_FACTOR_INTERVALS}
          value={selectedInterval}
          onChange={setSelectedInterval}
        />
        <TwoFactorInput
          visible={true}
          code={twoFACode}
          onCodeChange={setTwoFACode}
        />
        <Button
          loading={bob.areWeWaitingOnRails}
          onClick={() => handleSave()}
          disabled={!selectedInterval || !twoFACode}
        >
          Change 2FA Timeout
        </Button>
      </Stack>
    </Modal>
  );
});

export default TwoFactorTimeout;
